import React from "react";
import { ArrowUpRight, Play } from "lucide-react";

type Interview = {
  id: string;
  url: string;
  image: string;
  width: number;
  height: number;
  alt: string;
  thumbnailLabel: string;
  title: string;
  description: string;
  publishedAt: string;
  materialLabel: string;
};

const interviews: Interview[] = [
  {
    id: "droga-do-wolnosci-od-dlugow",
    url: "https://dziennikzachodni.pl/11-milionow-polakow-z-zobowiazaniami-czy-upadlosc-konsumencka-to-skuteczna-droga-do-wolnosci-od-dlugow/ar/c3p2-28782509",
    image: "/manus-storage/dziennik-zachodni-interview-1280_3b6369d3.webp",
    width: 1280,
    height: 760,
    alt: "Dwóch mężczyzn podczas rozmowy w studiu Dziennika Zachodniego",
    thumbnailLabel: "Wywiad z Piotrem Kwakiem",
    title: "Czy upadłość konsumencka to skuteczna droga do wolności od długów?",
    description:
      "Piotr Kwak z Upadłości Ekspert opowiada o indywidualnej ocenie sytuacji i dostępnych formach pomocy.",
    publishedAt: "3 marca 2026 r.",
    materialLabel: "Materiał Upadłości Ekspert",
  },
  {
    id: "czas-wyjscia-z-dlugow",
    url: "https://dziennikzachodni.pl/upadlosc-konsumencka-w-praktyce-ile-naprawde-trwa-wyjscie-z-dlugow/ar/c3p2-28789703",
    image: "/manus-storage/pasted_file_mbmQGp_image_78d65e27.png",
    width: 1280,
    height: 720,
    alt: "Piotr Kwak podczas rozmowy w studiu Dziennika Zachodniego",
    thumbnailLabel: "Wywiad z Piotrem Kwakiem",
    title:
      "Upadłość konsumencka w praktyce. Ile naprawdę trwa wyjście z długów?",
    description:
      "Piotr Kwak z Upadłości Ekspert opowiada o realnych terminach postępowania, etapach wychodzenia z długów i możliwościach szybszego zakończenia sprawy.",
    publishedAt: "5 marca 2026 r.",
    materialLabel: "Materiał informacyjny Upadlosci-Ekspert.pl",
  },
];

export function VideoFeature({ embedded = false }: { embedded?: boolean }) {
  const content = (
    <div className="video-feature-grid video-feature-grid--interviews">
      {interviews.map(interview => (
        <article className="video-interview-card" key={interview.id}>
          <div className="video-thumbnail">
            <a
              className="video-thumbnail-link"
              href={interview.url}
              target="_blank"
              rel="noopener noreferrer"
              aria-label={`Otwórz wywiad: ${interview.title}`}
            >
              <img
                loading="lazy"
                decoding="async"
                src={interview.image}
                width={interview.width}
                height={interview.height}
                alt={interview.alt}
              />
              <span className="video-thumbnail-label">
                {interview.thumbnailLabel}
              </span>
              <span className="play-mark" aria-hidden="true">
                <Play fill="currentColor" size={23} />
              </span>
            </a>
          </div>
          <div className="video-context">
            <span className="section-kicker">rozmowa z ekspertem</span>
            <h3 id={`video-${interview.id}-heading`}>{interview.title}</h3>
            <p>{interview.description}</p>
            <a
              className="video-link"
              href={interview.url}
              target="_blank"
              rel="noopener noreferrer"
            >
              Obejrzyj wywiad <ArrowUpRight size={18} />
            </a>
            <small>
              {interview.materialLabel} · {interview.publishedAt}
            </small>
          </div>
        </article>
      ))}
    </div>
  );

  return embedded ? (
    <div className="embedded-video" aria-label="Wywiady w Dzienniku Zachodnim">
      {content}
    </div>
  ) : (
    <section
      className="video-feature"
      aria-label="Wywiady w Dzienniku Zachodnim"
    >
      <div className="shell-wide">{content}</div>
    </section>
  );
}
